var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "brand-slider" }, [
    _c("div", { staticClass: "brand-slider__inner page-width" }, [
      _c(
        "div",
        { ref: "container", staticClass: "page-width swiper-container" },
        [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.brands, function (brand, idx) {
              return _c("div", { key: idx, staticClass: "swiper-slide" }, [
                _c("a", {
                  staticClass: "swiper-slide__url",
                  attrs: { href: brand.url },
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "swiper-slide__image",
                  attrs: { src: brand.image, alt: brand.image_alt },
                }),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-slide__left-shader" }),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-slide__right-shader" }),
        ]
      ),
      _vm._v(" "),
      _c("div", { ref: "prev", staticClass: "swiper-button-prev" }),
      _vm._v(" "),
      _c("div", { ref: "next", staticClass: "swiper-button-next" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }